<template>
  <div class="form_con">
    <div class="fixed newlyAdded">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
            <div class="search_con m_flex_box flex_vc">查看固话或区域变更</div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <van-form :scroll-to-error="true">
      <h5>
        委托书:(加盖公章的扫描件,jpg格式.写明某某公司委托某某办理入网手续,打印后加盖公章，扫描备用.)
      </h5>
      <div class="pic_con">
        <!-- <van-uploader
          :before-read="beforeRead"
          :after-read="afterReadEleven"
         
        > -->
        <img
          :src="submitObj.trustImg"
          alt=""
          class="small"
          v-if="submitObj.trustImg"
        />
        <img :src="seatImg" alt="" class="small" v-else />
        <!-- </van-uploader> -->
      </div>
      <van-field
        readonly
        v-model="submitObj.corpPhone"
        type="text"
        name="企业固话"
        label="企业固话:"
        placeholder="请输入企业固话"
      />
      <van-field
        clickable
        name="picker"
        :value="areaRole"
        label="所在区域："
        placeholder="点击选择区域"
        readonly
      />
      <van-cell-group>
        <van-field
          readonly
          v-model="submitObj.remark"
          rows="3"
          autosize
          label="备注(选填):"
          type="textarea"
          placeholder="请输入备注"
          maxlength="50"
          show-word-limit
        />
      </van-cell-group>
      <van-field
        readonly
        v-model="submitObj.state"
        label="审核状态:"
        type="text"
        v-if="applyId != ''"
      />
      <van-cell-group v-if="applyId != ''">
        <van-field
          readonly
          v-model="submitObj.rejectReason"
          rows="3"
          autosize
          label="未通过原因:"
          type="textarea"
          placeholder="无"
        />
      </van-cell-group>

      <div style="margin: 16px; padding-bottom: 16px">
        <van-button
          block
          type="info"
          @click="modifyApply"
          v-show="submitObj.process == 3"
          >修改申请</van-button
        >
        <van-button
          block
          type="info"
          @click="revokeApply"
          v-show="submitObj.process == 2"
          >撤销申请</van-button
        >
      </div>
    </van-form>
    <!-- <van-overlay
      :show="show"
      class="m_flex_box flex_hc flex_vc"
      @click="show = false"
    > -->
    <!-- <div class="wrap m_flex_box flex_vc flex_hc">
        <img src="@/assets/img/sfz_s.png" alt="" />
      </div>
    </van-overlay> -->
  </div>
</template>

<script>
let timmer = null;
import qs from "qs";
export default {
  data() {
    return {
      submitObj: {
        corpPhone: "",
        trustImg: "", //委托书
        process: "", //流程
        applyType: "", //变更类型
        rejectReason: "", //驳回原因
        state: "", //审核状态
      },
      seatImg: require("@/assets/img/up.png"),
      applyId: this.$route.query.applyId || "",
      areaList: [
        {
          text: "市区",
          v: 1,
        },
        {
          text: "贾汪",
          v: 2,
        },
        {
          text: "睢宁",
          v: 3,
        },
        {
          text: "邳州",
          v: 4,
        },
        {
          text: "沛县",
          v: 5,
        },
        {
          text: "丰县",
          v: 6,
        },
        {
          text: "铜山",
          v: 7,
        },
        {
          text: "新沂",
          v: 8,
        },
        {
          text: "高新",
          v: 9,
        },
      ],
      areaRole: "",
    };
  },
  components: {},
  mounted() {
    // this.natureInit();
    // this.gradeInit();
    if (this.applyId != "") {
      this.infoInit();
    }
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    //修改
    modifyApply() {
      this.$router.push({
        path: "/areaChange",
        query: {
          applyId: this.applyId,
        },
      });
    },

    //撤销
    revokeApply() {
      //  trustImg: this.submitObj.trustImg,
      this.$test
        .post(
          "spf/corpinfoapply/update",
          qs.stringify({
            applyId: this.applyId,
            process: "1",
          }),
          {
            headers: {
              xzfpftoken: sessionStorage.getItem("userId") || "",
            },
          }
        )
        .then((res) => {
          if (res.code == "000") {
            this.$toast("撤销成功");
            this.$router.go(-1);
            // this.$router.replace({
            //   path: "/myManagement",
            // });
          }
        });
    },
    //信息初始化
    infoInit() {
      this.$test
        .post(
          "spf/corpinfoapply/detail",
          qs.stringify({
            applyId: this.applyId,
          }),
          {
            headers: {
              xzfpftoken: sessionStorage.getItem("userId") || "",
            },
          }
        )
        .then((res) => {
          if (res.code == "000") {
            var newObj = Object.assign(res.result, {});
            if (newObj.process == 1) {
              newObj.state = "草稿";
            } else if (newObj.process == 2) {
              newObj.state = "待审核";
            } else if (newObj.process == 3) {
              newObj.state = "未通过";
            } else if (newObj.process == 4) {
              newObj.state = "已通过";
            } else {
              newObj.state = "已归档";
            }
            for (var i = 0; i < this.areaList.length; i++) {
              if (newObj.corpRemark == this.areaList[i].v) {
                this.areaRole = this.areaList[i].text;
              }
            }
            this.submitObj = newObj;
          } else {
            this.$toast(res.msg);
          }
        });
    },
    // testPostcode(data) {
    //   return /^\d{6}$/.test(data);
    // },
    // testPhone(data) {
    //   return /^1[3456789]\d{9}$/.test(data);
    // },
    // testIdCard(data) {
    //   return /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/.test(
    //     data
    //   );
    // },
  },
};
</script>
<style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.bg_gray {
  min-height: 100vh;
  background-color: #ffffff;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.top_header {
  height: 0.7rem;
  padding: 0.1rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
  &.top_sm {
    padding: 0.1rem;
  }
  .search_con,
  .search_con_l {
    height: 0.7rem;
    box-sizing: border-box;
    font-size: 0.3rem;
    padding: 0 0.3rem;
    color: #303030;
    i {
      font-size: 0.36rem;
      margin-right: 0.2rem;
    }
  }
  input {
    width: 80%;
    height: 0.7rem;
    background-color: transparent;
  }
  .search_con {
    font-weight: bolder;
    justify-content: center;
    width: 5.78rem;
  }
  .search_con_l {
    width: 5.72rem;
  }
  .to_map {
    font-size: 0.28rem;
    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
.form_con {
  // padding: 0.3rem 0rem;
  // .newlyAdded {
  //   position: relative;
  //   h3 {
  //     line-height: 1rem;
  //     font-size: 0.36rem;
  //     font-weight: 800;
  //   }
  // }
  /deep/ .b_f {
    line-height: 32px;
  }
}
h5 {
  font-size: 14px;
  padding: 10px 16px 0;
  color: #646566;
}
.pic_con {
  padding: 16px 16px;
  position: relative;
  .small {
    width: 2.56rem;
    height: 1.63rem;
  }
  .big {
    width: 2.18rem;
    height: 3.4rem;
  }
  p {
    color: #474747;
    font-size: 12px;
    width: 2.56rem;
    text-align: center;
    margin-top: 0.1rem;
    color: #666;
  }
  &:after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}
.col_blue {
  color: #2f72f5;
  font-size: 0.26rem;
}
.wrap {
  background-color: #fff;
  width: 5.8rem;
  height: 7.84rem;
  border-radius: 0.02rem;
  img {
    width: 4.04rem;
    height: 6.28rem;
  }
}
</style>